/* v-c-clickaway (CoreUI v3 directive) for Vue 3 */
function bind (el, binding) {
  unbind(el)
  const handler = binding.value
  if (typeof handler !== 'function') return
  el.__cClickaway__ = (e) => {
    if (!el.contains(e.target)) handler(e)
  }
  // defer so the click that opened the menu doesn't close it immediately
  setTimeout(() => { if (el.__cClickaway__) document.addEventListener('click', el.__cClickaway__) }, 0)
}
function unbind (el) {
  if (el.__cClickaway__) {
    document.removeEventListener('click', el.__cClickaway__)
    delete el.__cClickaway__
  }
}
export const CClickaway = {
  mounted: bind,
  updated (el, binding) {
    if (binding.value !== binding.oldValue) bind(el, binding)
  },
  unmounted: unbind
}
